export const primaryColor = "#487fd6";
export const secondaryColor = "#e04d78";
export const colorArray = [
  primaryColor,
  secondaryColor,
  "#80B300",
  "#FF6633",
  "#991AFF",
  "#B33300",
  "#CC9999",
  "#99E6E6",
  "#FF33FF",
  "#66664D"
];
